export interface LanguageState {
    currentLanguage: string;
    dir: string;
    translations: any;
}

export const initialLanguageState: LanguageState = {
    currentLanguage: 'en',
    dir: 'ltr',
    translations: {}
};
